import React from 'react';
import Input from '../Input';
import Alert from '../Alert';
import { ApolloConsumer } from '@apollo/client';
// import { CHANGE_PASSWORD } from '../Graphql/Mutations/ChangePasswordMutation'; // you should create this mutation
import { mutateData } from '../Service/graphQlService';
import { UPDATE_PASSWORD } from '../Graphql/Mutations/LoginMutation';

export default class ChangePassword extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
            email:'',
			oldPassword: '',
			newPassword: '',
			confirmPassword: '',
			isBusy: false,
			error: null,
			success: null,
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleChange(e) {
		this.setState({ [e.currentTarget.name]: e.currentTarget.value });
	}
    parseJWT(token) {
        if(token){
        const base64Url = token.split('.')[1];  // The payload is the second part of the JWT
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
 
        return JSON.parse(jsonPayload);
    }
    }

	handleSubmit(e) {
		e.preventDefault();

		const { oldPassword, newPassword, confirmPassword } = this.state;
        var token = localStorage.getItem('authToken');
        const decodedToken = this.parseJWT(token);
        const email = token ? decodedToken.email: null;
        console.log(email)
		if (newPassword !== confirmPassword) {
			this.setState({ error: "New passwords do not match", success: null });
			return;
		}

		this.setState({ isBusy: true, error: null });
		mutateData(UPDATE_PASSWORD, {
            email,
            newPassword,
			oldPassword
		})
			.then(res => {
				if (res && res.data && res.data.updatePassword && res.data.updatePassword.success) {
					this.setState({
						success: "Password updated successfully!",
						error: null,
						isBusy: false,
						oldPassword: '',
						newPassword: '',
						confirmPassword: '',
					});
                    setTimeout(() => {
                        this.props.onPasswordChange();
                    }, 1500);
                    
				} else {
					this.setState({
						error: res && res.data && res.data.updatePassword && res.data.updatePassword.error||"Password update failed.",
						success: null,
						isBusy: false,
					});
				}
			})
			.catch(err => {
				this.setState({ error: "Something went wrong!", success: null, isBusy: false });
			});
	}

	render() {
		return (
			<ApolloConsumer>
				{client => {
					if (!this.client) {
						this.client = client;
					}
					return (
						<div className='Login' style={{	 height: "100vh" }} >
							<div className='Login_body'>
								<form onSubmit={this.handleSubmit}>
									<Input
										type="password"
										name="oldPassword"
										value={this.state.oldPassword}
										placeholder="Current Password"
										onChange={this.handleChange}
									/>
									<Input
										type="password"
										name="newPassword"
										value={this.state.newPassword}
										placeholder="New Password"
										onChange={this.handleChange}
									/>
									<Input
										type="password"
										name="confirmPassword"
										value={this.state.confirmPassword}
										placeholder="Confirm New Password"
										onChange={this.handleChange}
									/>
									<button data-busy={this.state.isBusy} style={{margin:'0px', marginTop:'12px',backgroundColor: "rgb(133 177 75)"}}>Update Password</button>
								</form>
								{
									this.state.error && <Alert type='error'>{this.state.error}</Alert>
								}
								{
									this.state.success && <Alert type='success'>{this.state.success}</Alert>
								}
							</div>
						</div>
					);
				}}
			</ApolloConsumer>
		);
	}
}
